import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import { formatClk } from 'chessboard/model/time/format-clk';

/**
 * Set the clk value on a node.
 */
export function setClkOnNode({
  api,
  node,
  clk,
}: {
  api: API.ExtendedAPI;
  node: Game.Move.Node;
  clk: number | null;
}): void {
  const { line, move } = node.ids;
  const game = api.getContext().game;

  if (!node.commands) {
    node.commands = {};
  }

  game.updateNode(
    {
      // JCE does not do a merge deep with updateNode, so `clk` must be merged
      // into `node.commands` in order not to overwrite things.
      commands: Object.assign(node.commands, {
        clk: clk === null ? clk : formatClk(clk),
      }),
    },
    move,
    line,
  );
}
